module.exports = __webpack_public_path__ + "img/icon105.a7964c15.jpeg";